import { render } from "./MultiSelectControl.vue?vue&type=template&id=5edf4162"
import script from "./MultiSelectControl.vue?vue&type=script&lang=js"
export * from "./MultiSelectControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MultiSelectControl.vue"]])

export default __exports__